export function loadState() {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
}

export function saveState(state) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (err) {
    // Just log it
    console.error(err);
  }
}

export function getPreferences(key) {
  try {
    return JSON.parse(localStorage.getItem(key)) || {};
  } catch (err) {
    return {};
  }
}

export function setPreferences(key, prefs = {}) {
  const currentPrefs = getPreferences(key);
  localStorage.setItem(
    key,
    JSON.stringify({
      ...currentPrefs,
      ...prefs
    })
  );
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js